export function discountErrorHandling(userErrors): string[] {
  const errorMessages = []
  userErrors.forEach((value) => {
    switch (value.code) {
      case 'BLANK':
        errorMessages.push('入力値が空白です。')
        break
      case 'CONTAINS_HTML_TAGS':
        errorMessages.push('入力値にHTMLタグが含まれています。')
        break
      case 'CONTAINS_URL':
        errorMessages.push('入力値にURLが含まれています。')
        break
      case 'customer_selection':
        errorMessages.push(
          'ディスカウントが紐づけられている顧客が含まれています。'
        )
        break
      case 'UNDEFINED_CUSTOMER':
        errorMessages.push('登録されていない顧客が含まれています。')
        break
      case 'NUMBER_LIMIT':
        errorMessages.push(
          ' 最大ディスカウント可能回数は半角数字で入力してください。'
        )
        break
      case 'TOO_LONG':
        if (value.field.indexOf('title') !== -1) {
          errorMessages.push('タイトルを確認してください。')
        } else if (value.field.indexOf('description') !== -1) {
          errorMessages.push('説明を確認してください。')
        } else {
          errorMessages.push('入力値が長すぎないことを確認してください。')
        }
        break
    }
  })

  return errorMessages?.filter((e, i) => errorMessages?.indexOf(e) === i)
}
